import { Directive, forwardRef, HostListener, Input, OnChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlag } from '../services/feature-flag';
import { FeatureFlagService } from '../services/feature-flag.service';
import { Authorizer, AUTHORIZERS } from './authorizer';

@Directive({
  selector: '[authorizeFeatureFlag]',
  providers: [
    {
      provide: AUTHORIZERS,
      useExisting: forwardRef(() => AuthorizeFeatureFlagDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class AuthorizeFeatureFlagDirective implements Authorizer, OnChanges {
  // keyof typeof gives us nice auto-complete in templates
  @Input('authorizeFeatureFlag') featureFlag?: keyof typeof FeatureFlag;

  readonly order = 0;

  private input$ = new BehaviorSubject<null>(null);

  readonly isAuthorizedChanges = this.input$.pipe(
    map(
      () => !this.featureFlag || this.featureFlagService.isEnabled(FeatureFlag[this.featureFlag]),
    ),
  );

  constructor(private featureFlagService: FeatureFlagService) {}

  ngOnChanges() {
    this.input$.next(null);
  }

  /**
   * When opening the "enable feature" link in a new tab this ensures
   * the feature is rechecked on returning to the old tab
   */
  @HostListener('window:focus')
  onWindowFocus() {
    this.input$.next(null);
  }
}
